var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({attrs:{"type":"text"}},'el-button',_vm.$attrs,false),_vm.$listeners),[(_vm.type=='edit')?_c('i',{staticClass:"el-icon-edit-outline"}):_vm._e(),_vm._v(" "),(_vm.type=='detail')?_c('i',{staticClass:"el-icon-tickets"}):_c('i',{staticClass:"el-icon-circle-check success"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0d13b2d6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/src/common.vue
// module id = 176
// module chunks = 0